module.exports = __webpack_public_path__ + "static/tree-l-mobile-f4324649a41d8840aa0f777008653902.png";